import { render, staticRenderFns } from "./PlnDocument.vue?vue&type=template&id=383efa66&"
import script from "./PlnDocument.vue?vue&type=script&lang=js&"
export * from "./PlnDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports